import React, { useState } from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import Style from '../viewSummary.module.css'
import { addDays, customRange, presetRange, startOfToday } from '../summaryFormat'
const PRESETS = [7, 30, 90]

const DateRangeFilter = ({ range, onChange, disabled }) => {
    const activePreset = range ? range.preset : 'all'
    const [showCustom, setShowCustom] = useState(activePreset === 'custom')
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)
    const [showErrors, setShowErrors] = useState(false)

    const today = startOfToday()
    const tomorrow = addDays(today, 1)

    const choose = (next) => {
        setShowCustom(false)
        setShowErrors(false)
        onChange(next)
    }

    const applyCustom = () => {
        if (!startDate || !endDate) {
            setShowErrors(true)
            return
        }
        setShowErrors(false)
        onChange(customRange(startDate, endDate))
    }

    const segmentClass = (isActive) => [Style.segment, isActive ? Style.segmentActive : ''].join(' ')

    return (
        <div className={Style.filter}>
            <div className={Style.segmented} role="group" aria-label="Date range">
                <button
                    type="button"
                    className={segmentClass(activePreset === 'all' && !showCustom)}
                    aria-pressed={activePreset === 'all' && !showCustom}
                    disabled={disabled}
                    onClick={() => choose(null)}
                >
                    All time
                </button>
                {PRESETS.map((days) => (
                    <button
                        key={days}
                        type="button"
                        className={segmentClass(activePreset === days && !showCustom)}
                        aria-pressed={activePreset === days && !showCustom}
                        disabled={disabled}
                        onClick={() => choose(presetRange(days))}
                    >
                        {days}D
                    </button>
                ))}
                <button
                    type="button"
                    className={segmentClass(showCustom || activePreset === 'custom')}
                    aria-pressed={showCustom || activePreset === 'custom'}
                    aria-expanded={showCustom}
                    disabled={disabled}
                    onClick={() => setShowCustom(!showCustom)}
                >
                    <i className="uil-calendar-alt" aria-hidden="true" /> Custom
                </button>
            </div>

            {showCustom ? (
                <div className={Style.customRange}>
                    <DatePicker
                        className={[Style.dateInput, showErrors && !startDate ? Style.dateInputError : ''].join(' ')}
                        placeholderText="Start date"
                        selected={startDate}
                        selectsStart
                        startDate={startDate}
                        endDate={endDate}
                        maxDate={endDate ? addDays(endDate, -1) : today}
                        dateFormat="dd MMM yyyy"
                        onChange={(date) => {
                            setStartDate(date)
                            if (date && endDate && date >= endDate) setEndDate(null)
                        }}
                        aria-label="Start date"
                    />
                    <span className={Style.rangeDash} aria-hidden="true">–</span>
                    <DatePicker
                        className={[Style.dateInput, showErrors && !endDate ? Style.dateInputError : ''].join(' ')}
                        placeholderText="End date"
                        selected={endDate}
                        selectsEnd
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate ? addDays(startDate, 1) : null}
                        maxDate={tomorrow}
                        dateFormat="dd MMM yyyy"
                        onChange={setEndDate}
                        aria-label="End date"
                    />
                    <button type="button" className={Style.primaryButton} disabled={disabled} onClick={applyCustom}>
                        Apply
                    </button>
                </div>
            ) : null}
        </div>
    )
}

export default DateRangeFilter
